module.exports = __webpack_public_path__ + "img/timequestion.a62f65a0.png";